/* eslint-disable no-undef */
// ADD UNDERLINE ON SCROLL

let ticking = false;
let has_border = false;

window.addEventListener('scroll', function () {
    let y = window.pageYOffset;

    if (!ticking) {
        window.requestAnimationFrame(function () {
            var navbar = document.getElementById('navbarNav');
            if (y > 0 && has_border == false) {
                // ADD BORDER
                navbar.classList.add('navigation--has-border');
                has_border = true
            } else if (y == 0 && has_border == true) {
                // REMOVE BORDER
                navbar.classList.remove('navigation--has-border');
                has_border = false
            }
            ticking = false;
        });

        ticking = true;
    }
});

// MOBILE NAVBAR

const html = document.documentElement
// const navigationMenu = document.querySelector('.o-navigation--main .menu')

const hamburger = document.querySelector('.o-navigation--main .hamburger')
window.addEventListener('load', () => {
    hamburger.addEventListener('click', function () {
        html.classList.toggle('navigation--is-open')
        this.classList.toggle('active')
        const targetElement = document.querySelector('.o-navigation--main .navigation--right');
        targetElement.classList.toggle('active');
        ScrollLock.toggleBodyScroll(targetElement)
    })
})

// eslint-disable-next-line no-unused-vars
$(function () {
    $('a[href*=#]').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top,
        }, 500, 'linear');
    });
});



// WEBPACK FOOTER //
// ./js/modules/navigation/main.js